<template>
    <div class="row">
        <template v-for="(abono, index) in abonos">
            <div :key="index + 'a'" class="col-12 mt-2">
                <div class="card bg-light">
                    <div class="card-body">
                        <strong class="text-primary">ABONO {{ parseInt(index) + 1 }}.</strong>
                        <strong class="text-uppercase">
                            <span v-if="abono.asiento && abono.asiento.zona_nombre">:{{ abono.asiento.zona_nombre }}</span>
                            <span v-if="abono.asiento && abono.asiento.fila">/ FILA: {{ abono.asiento.fila }}</span>
                            <span v-if="abono.asiento && abono.asiento.asiento">/ BUTACA: {{ abono.asiento.asiento }}</span>
                            <span v-if="abono.plaza">  {{ abono.plaza.plazaName }}</span>
                        </strong>
                    </div>
                </div>
            </div>
            <div :key="index  + 'b'" class="columna-abono-6 marg-ab marg-mv">
                <div class="row">
                    <div class="col-12">
                        <span class="h4 text-uppercase"><strong>{{ abono.nombre }} {{ abono.apellidos }}</strong></span>
                    </div>
                    <div class="col-12">
                        <i class="fas fa-id-card"></i> {{ abono.dni }}
                    </div>
                    <div class="col-12">
                        <i class="fas fa-envelope"></i> {{ abono.email }}
                    </div>
                    <div class="col-12">
                        <i class="fas fa-phone"></i> {{ abono.telefono }}
                    </div>
                    <div class="col-12" v-if="urls_imprimir.length > 0">
                        <Button :href="urls_imprimir[index]" target="blank_">IMPRIMIR ABONO</Button>
                    </div>
                </div>
            </div>
            <div :key="index  + 'c'" class="columna-abono-6">
                <div class="row">
                    <div class="col-12 spa-ab marg-ab">
                        <strong>TIPO DE ABONO</strong>
                    </div>
                    <div class="col-12 marg-ab">
                        <span class="h3 text-uppercase"><strong>{{ abono.precio.descripcion }}</strong></span>
                    </div>
                    <template>
                        <div class="col-12 spa-ab marg-ab">
                            <strong>
                                PRECIO ABONO
                                <span v-if="abono.descuento_aplicado > 0">
                                    (DESCUENTO DEL 
                                    <span class="text-primary pdng-ab">
                                        {{ abono.descuento_aplicado }}%
                                    </span>
                                    )
                                </span>
                                <span v-else-if="abono.descuento_monedero">
                                    (DESCUENTO DE 
                                    <span class="text-primary pdng-ab">
                                        {{ abono.descuento_monedero | formatear_precio }}
                                    </span>
                                    )
                                </span>
                                <span v-else-if="abono.descuento_integro">
                                    (DESCUENTO DE 
                                    <span class="text-primary">
                                        {{ abono.descuento_integro | formatear_precio }}
                                    </span>
                                    )
                                </span>
                            </strong>
                        </div>
                        <div class="col-12 mgn-pr">
                            <span class="h4" v-if="abono.descuento_aplicado > 0 || abono.descuento_monedero || abono.descuento_integro > 0">
                                <strike>
                                    <strong>
                                        {{ abono.precio.precio_total_taquilla | formatear_precio }}
                                    </strong>
                                </strike>
                            </span>
                            <span class="h2 ml-2">
                                <strong v-if="abono.descuento_monedero">
                                    {{ totalConMonedero(abono.precio, abono.descuento_monedero) | formatear_precio }}
                                </strong>
                                <strong v-if="abono.descuento_integro">
                                    {{ totalConMonedero(abono.precio, abono.descuento_integro) | formatear_precio }}
                                </strong>
                                <strong v-else>
                                    {{ totalConDescuento(abono.precio, abono.descuento_aplicado) | formatear_precio }}
                                </strong>
                            </span>
                        </div>
                    </template>
                    <template v-if="abono.plazos">
                        <div class="col-12 mt-3 pdng-ab">
                            <strong>PLAZOS:</strong>
                        </div>
                        <div class="col-12 pdng-ab">
                            <ul>
                                <li v-for="(plazo, key) in abono.plazos_pendientes" :key="key">
                                    <template v-if="plazo.gastos_internos == 0">
                                        Plazo: {{ ++key }} <span v-if="plazo.informacion">({{ plazo.informacion }})</span> - {{ plazo.importe + plazo.gastos  | formatear_precio }}  <span v-if="abonos[0].precio.price_management_online && key > 1">/ (Gastos de gestión: {{ abonos[0].precio.price_management_online }} €) </span>
                                    </template>
                                    <template v-else>
                                        Plazo: {{ ++key }} <span v-if="plazo.informacion">({{ plazo.informacion }})</span> - {{ plazo.importe  | formatear_precio }}
                                    </template>                                            
                                </li>
                            </ul>
                        </div>
                    </template>
                    <template v-if="abono.parcelasAsignadas && abono.parcelasAsignadas.length > 0 && teatro.hash !== 'J1fKG9AarPuPNJ5hwY0t'">
                        <div class="col-12 spa-ab marg-ab">
                            <strong>PARCELAS ASIGNADAS</strong>
                            <ul class="">
                                <strong class="col-12 p-0">
                                    {{ abono.region }}
                                </strong>
                                <li v-for="parcela in abono.parcelasAsignadas" :key="parcela.id" class="col-12 p-0">
                                    PARCELA Nº {{ parcela.numero }}. - {{ parcela.precioSeleccionado.precio | formatear_precio }}
                                </li>
                            </ul>
                        </div>
                    </template>
                </div>
            </div>
        </template>
        <div class="col-12 spa-ab">
            <strong>TOTAL:  <span class="h4"><strong>{{ total | formatear_precio }}</strong></span></strong>
        </div>
        <div class="col-12 spa-ab">
            <strong>FORMA DE PAGO:  <span class="h4"><strong>{{ Array.isArray(datos_compra.metodo_pago) ? datos_compra.metodo_pago.map(i => i.nombre).join(', ') : datos_compra.metodo_pago.nombre }}</strong></span></strong>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['abonos', 'datos_compra', 'urls_imprimir'],
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            total() {
                var total = 0;

                for(var i in this.abonos) {
                    if(this.abonos[i].plazos) {
                        var precio = this.abonos[i].plazos_pendientes[0].importe;

                        if(! this.abonos[i].plazos_pendientes[0].gastos_internos) {
                            precio += this.abonos[i].plazos_pendientes[0].gastos;
                        }

                        total += precio;

                    } else {
                        var precio_total_taquilla = this.abonos[i].precio.precio;

                        var cantidad_descuento = (this.abonos[i].descuento_aplicado / 100) * precio_total_taquilla;

                        total += (precio_total_taquilla - cantidad_descuento);
                    }
                
                    if(this.abonos[i].descuento_monedero && this.abonos[i].descuento_monedero > 0) {
                        total -= this.abonos[i].descuento_monedero;
                    }

                    if(!this.abonos[i].plazos && this.abonos[i].descuento_integro && this.abonos[i].descuento_integro > 0) {
                        total -= this.abonos[i].descuento_integro;
                    }

                    if (!this.abonos[i].precio.price_management_interno) {
                        total += this.abonos[i].precio.price_management ?? this.abonos[i].precio.price_management_taquilla;
                    }

                    if(this.abonos[i].parcelasAsignadas && this.abonos[i].parcelasAsignadas.length > 0 && this.teatro.hash !== 'J1fKG9AarPuPNJ5hwY0t') {
                        for(var j in this.abonos[i].parcelasAsignadas) {
                            var parcela = this.abonos[i].parcelasAsignadas[j];
                            if(parcela.precioSeleccionado && parcela.precioSeleccionado.precio) {
                                total += parcela.precioSeleccionado.precio;
                            }
                        }
                    }
                }

                this.$emit('setTotal', total);

                return total;
            }
        },
        methods: {
            actualizado() {
                this.$emit('actualizado');
            },
            totalConDescuento(tipo_abono, descuento) {
                var desc = (descuento / 100) * tipo_abono.precio;
                var precioConDescuento = tipo_abono.precio - desc;

                if (!tipo_abono.price_management_interno) {
                    precioConDescuento += tipo_abono.price_management ?? tipo_abono.price_management_taquilla;
                }
            
                return precioConDescuento;
            },
            totalConMonedero(tipo_abono, monedero) {
                var precioConDescuento = tipo_abono.precio - monedero;

                if (!tipo_abono.price_management_interno) {
                    precioConDescuento += tipo_abono.price_management ?? tipo_abono.price_management_taquilla;
                }

                return precioConDescuento;
            }
        }
    }
</script>

<style scoped>
    .columna-abono-6 {
        -ms-flex: 0 0 50%;
        flex: 0 0 50%;
        max-width: 50%;
    }

    .mgn-pr {
        margin-left: 0px;
        padding-left: 4px;
    }

    .marg-ab {
        padding-left: 16px;
    }

    @media (max-width: 768px) {
        .font-mov {
            font-size: 20px !important;
        }

        .columna-abono-6 {
            -ms-flex: 0 0 100%;
            flex: 0 0 100%;
            max-width: 100%;
        }

        .spa-ab {
            margin-top: 12px;
        }

        .marg-ab {
            margin-left: 12px;
        }

        .pdng-ab {
            padding-left: 20px;
        }

        .mgn-pr {
            margin-left: 16px;
        }

        .marg-mv {
            padding-left: 4px;
        }
    }
</style>
